export const FETCH_ALERTS = 'FETCH_ALERTS';
export const FETCH_ALERTS_SUCCESS = 'FETCH_ALERTS_SUCCESS';
export const FETCH_ALERTS_FAIL = 'FETCH_ALERTS_FAIL';
export const RESET_ALERTS = 'RESET_ALERTS';
